import { render } from "./ChangeCoverConfirmation.vue?vue&type=template&id=03c81758"
import script from "./ChangeCoverConfirmation.vue?vue&type=script&lang=js"
export * from "./ChangeCoverConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__